import { format } from 'date-fns'
import subDays from 'date-fns/subDays'
import { leadByIdAdapter, leadsAdapter } from 'lead/adapter/leadsAdapter'
import { b2bApi } from 'shared/infrastructure/clients'
import { getUserInfo } from 'shared/infrastructure/storage'

const cpfPattern = '[0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2}'
const cnpjPattern = '[0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2}'
const documentCodePattern = `^(${cpfPattern}|${cnpjPattern})$`
const regexBorrowerDocumentCode = new RegExp(documentCodePattern)
const onlyNumbers = value => value?.replace(/\D/g, '')

export const omitEmptyParams = params =>
  Object.fromEntries(
    Object.entries(params).filter(key => key[1] !== '' && key[1] !== null),
  )

export const resolveDateRange = value => {
  if (value !== 0 && value !== 'ALL') {
    const formatDate = date => {
      return format(date, 'yyyy-MM-dd')
    }
    const start = subDays(Date.now(), value)
    return { startAt: formatDate(start), endAt: formatDate(Date.now()) }
  }
  return value
}

const resolveBorrowerQueryParam = value => {
  if (regexBorrowerDocumentCode.test(value)) {
    return { borrowerDocumentCode: onlyNumbers(value) }
  }
  return { borrowerFullName: value }
}

const getLeadsRequest = (
  limit = 10,
  offset = 0,
  query,
  productType = null,
  date = 0,
  stepName = null,
  situation = null
) => {
  let typeUser = getUserInfo()?.login?.user?.type
  let agentId = null
  if (typeUser == "AGENT") {
    agentId = getUserInfo()?.login?.user.id
  }

  return b2bApi
    .get('/proposals', {
      params: omitEmptyParams({
        limit,
        offset,
        productType,
        ...resolveBorrowerQueryParam(query?.trim()),
        ...resolveDateRange(date),
        stepName,
        situation,
        agentId
      }),
    })
    .then(response => leadsAdapter(response.data))
}

const getLeadByIdRequest = leadId => {
  return b2bApi
    .get(`/proposals/${leadId}`)
    .then(response => leadByIdAdapter(response.data))
}

export { getLeadsRequest, getLeadByIdRequest, leadsAdapter, leadByIdAdapter }
